<script>
export default {
  name: 'applicationConstants',
  publicServerBaseUrl: process.env.PUBLIC_SERVER_BASE_URL,
  flinksAPIBaseUrl: process.env.FLINKS_API_BASE_URL,
  flinksPUblicServerBaseUrl: process.env.FLINKS_PUBLIC_SERVER_BASE_URL,
  plaidPUblicServerBaseUrl: process.env.PLAID_PUBLIC_SERVER_BASE_URL,
  intercomAppId: process.env.INTERCOME_APP_ID,
  logInBodyRequest: {
    ClientAppId: process.env.CLIENT_APPLICATION_ID,
    ClientAppVersion: process.env.CLIENT_APPLICATION_VERSION
  },
  FlinksIFrameURL: process.env.FLINKS_IFRAME_URL,
  fetchCountryByAlphaCode: 'https://restcountries.eu/rest/v2/alpha/',
  footerData: {
    phoneNumber: '+1 (647) 259-1770‬',
    footerDescription: `© ${new Date().getFullYear()} Copyright QicSEND`
  },
  formsMessages: {
    field: name => {
      return { required: `${name} is required` }
    },
    between: (name, min, max) => {
      return { between: `${name} must be between ${min} and ${max}` }
    },
    recipient: {
      bankAccount: long => `Bank account number should be ${long} characters long.\t\n Example: ${new Array(long).join('9')}`,
      remarks: long => `Example: To Family`,
      iban: long => `IBAN should be ${long} characters long.\t\n Example: ${new Array(long).join('9')}`,
      bic: long => `BIC should be ${long} characters long.\t\n Example: A1B2C3D4E5F`
    },
    minLength: number => `Your data must be at least ${number} characters.`,
    maxLength: number => `Your data must be at most ${number} characters.`,
    email: {
      required: 'Please enter your email address.',
      invalid: 'Please enter a valid email address.'
    },
    password: {
      required: 'Please enter your password.',
      checkCurrenctPassword: 'Password doesn\'t match current',
      minLength: number =>
        `Your password must be at least ${number} characters.`,
      strongPassword: (max, min) => `Passwords must be a uppercase letter, a lowercase letter, a number or a special character, be more than ${min} characters and be less than ${max} characters long.`
    },
    mobileNumber: {
      required: 'please enter your mobile number',
      invalid: 'please enter valid mobile number',
      length: 'mobile number should be 10 digits'
    },
    PhoneVerificationCode: {
      required: 'Verification code is required',
      verify: 'Please Verify Mobile Number'
    }
  },
  surveyRedirection: {
    eTransfer: {
      statusForFunding: ['Waiting For Funding', 'Funded'],
      statusForMoneyTransfer: ['Completed']
    },
    eft: {
      statusForFunding: ['Waiting For Funding', 'Funded'],
      statusForMoneyTransfer: ['Completed']
    },
    interacOnline: {
      statusForFunding: ['Waiting For Funding', 'Funded'],
      statusForMoneyTransfer: ['Completed']
    }
  },
  pagination: {
    recipientPageSize: 10,
    transactionHistoryPageSize: 5
  },
  enableChatBox: false,
  afterCompleteUserProfile: false,
  afterFirstFundingTransaction: false,
  afterFirstMoneyTransfer: false,
  afterMonthFromLoginDate: false,
  isPhoneVerificationEnabled: false,
  plaidEnvironment: process.env.PLAID_ENV,
  plaidProducts: process.env.PLAID_PRODUCTS,
  financialApp: 1,
  appOffline: false
}
</script>



// WEBPACK FOOTER //
// src/constants/ApplicationConstants.vue